import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import type { AvailabilityFilters, AvailabilityMode } from '@/types/ui/resource-availability'
import { useLanguage } from '@/contexts/language-context'

interface AvailabilityTogglesProps {
  filters: AvailabilityFilters
  onModeChange: (mode: AvailabilityMode) => void
}

export function AvailabilityToggles({ filters, onModeChange }: AvailabilityTogglesProps) {
  const { dictionary } = useLanguage()
  const t = dictionary?.resourceAvailability?.toggles
  return (
    <ToggleGroup
      type="single"
      value={filters.mode}
      onValueChange={(v: string) => v && onModeChange(v as AvailabilityMode)}
      className="bg-muted rounded-md p-0.5 border-0 h-8"
    >
      <ToggleGroupItem
        value="allocated"
        className="text-xs px-2.5 h-7 border-0 text-foreground/70 hover:text-foreground hover:bg-transparent data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm data-[state=on]:font-medium"
      >
        {t?.allocated || 'Allocated %'}
      </ToggleGroupItem>
      <ToggleGroupItem
        value="available"
        className="text-xs px-2.5 h-7 border-0 text-foreground/70 hover:text-foreground hover:bg-transparent data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm data-[state=on]:font-medium"
      >
        {t?.available || 'Available %'}
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
